<div class="relative-container">
  <a class="language" (click)="toggleMenu(true)" [matMenuTriggerFor]="appMenu3">
    <div class="bkg">
    <mat-icon>language</mat-icon>
    </div>
  </a>
  <mat-menu #appMenu3="matMenu">
    <ul class="list-style">
        <ng-container *ngFor="let language of supportedLanguages; let i = index">
          <li (click)="onLanguageSelect(language.value)"
              [ngClass]="{'selected' : currentLanguage === language.value}"
          >
            {{language.display}}
          </li>
          <hr *ngIf="i+1 < supportedLanguages.length">
        </ng-container>
    </ul>
  </mat-menu>
</div>
